// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "GuDatagridClientAsync.umd.min." + (chunkId === 148 ? "gu-datagrid-client" : chunkId) + ".js";
};